/*
  File Serves The Report of Problem Solved By The User of Any Batch
 */
import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Checkbox, Button } from '@mui/material';
import Util from "../../Service/util";
import Service from "../../Service/http";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ReactTable from 'react-table-6';
import { Link, useNavigate } from 'react-router-dom'
import "react-table-6/react-table.css";
import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table-hoc-fixed-columns/lib/styles.css'
import { VscCloudDownload,VscAdd, VscCloudUpload } from "react-icons/vsc"
import { FcDownload } from "react-icons/fc";
import {BeatLoader, FadeLoader} from "react-spinners";
import { useSearchParams } from "react-router-dom";
import { CircularProgress, Tooltip, IconButton, Modal, Box } from '@mui/material';
import {TbTrash} from "react-icons/tb"
import * as XLSX from 'xlsx';
import XlsxPopulate from 'xlsx-populate/browser/xlsx-populate'

const ReactTableFixedColumns = withFixedColumns(ReactTable);
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const getSampleData = () => {
  return (
    <>
      <p>Sample excel sheet data:</p>
      <Link
        className="float-start mb-2"
        to="/files/Problem_Reports_sample.xlsx"
        target="_blank"
        download
      >
        <FcDownload /> Download Sample
      </Link>
    </>
  );
};

function ProblemReport() {
  
  const service = new Service();
  const util = new Util();
  let [loggedIn, SetLoggedIn] = useState(false);
  let [isAdmin, SetIsAdmin] = useState(false);
  let [paramsObj,setParamsObj] = useState({
    batchParams:{},
    siteParams:{},
    problemParams:{}
  })
  let [role, SetRole] = useState("student");
  let [ batches, SetBatches ] = useState(['All Batches']);
  let [filteredBatches,setfilteredBatches]  = useState([])
  let [filteredContests, setfilteredContests] = useState([]);
  let [contests, SetContests] = useState([]);
  let [searchContests, SetSearchContests] = useState();
  let [ data, SetData] = useState([]);
  let [Page, SetPage] = useState(1)
  let [FinalPage, SetFinalPage] = useState(-1);
  let [PageSize, SetPageSize] = useState(50)
  let [PageSizeOption, SetPageSizeOption] = useState([5,10,20,25,50,100])
  let [QueryButton, SetQueryButton] = useState(false);
  let [QueryText, SetQueryText] = useState("Search Problems");
  let [SiteOptions, SetSitesOptions] = useState([]);
  let [filteredSites, setfilteredSites] = useState("*");
  let [loading, SetLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  let [loadingProblems, SetLoadingProblems] = useState(false);
  const navigate = useNavigate()
  const [historyData,SetHistoryData] = useState([])
  const [checked, setChecked] = React.useState(false);
  const [historyChanged,setHistoryChanged]= useState(true)
  const [age, setAge] = React.useState('');
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const TABLE_HEADER_COLOR = "ffffff";
  const TABLE_BODY_COLOR = "66cdfd";
  const PROBLEM_NOT_SOLVED_COLOR = "ff93a3";
  const PROBLEM_SOLVED_COLOR = "73ff9a"

  const getContests = (json) => {
    let contests = [];
    let j = 1;
    for (let item in json.data) {
      let problems = json.data[item]?.problems || {};
      let solvedCount = Object.values(problems).filter(
        (problem) => problem.isSolved
      ).length;

      let totalScore = 0;
      for (let problem in problems) {
        if (problems[problem].isSolved) {
          totalScore += problems[problem].score ?? 100;
        }
      }

      contests.push({
        name: json.data[item].name,
        userId: json.data[item].user_id,
        rollNumber: json.data[item].roll_number,
        problems: json.data[item]?.problems,
        totalSolved: solvedCount,
        totalScore: totalScore
      });
    }

    // Sort the contests array by totalScore in descending order
    contests.sort((a, b) => b.totalScore - a.totalScore);

    // Assign rank based on sorted order
    contests.forEach((contest, index) => {
      contest.rank = index + 1;
    });

    return contests;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet);
      const batchesList = json.map(row => row.batches).filter(batch => batch);
      
      let contestList = []

      SetLoading(true)
      await service.post('api/problems/details', { problems : json }).then((response) => {
        contestList = response.data;
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        SetLoading(false);
      })

      setfilteredBatches(batchesList);
      setfilteredContests(contestList);
    };
    reader.readAsArrayBuffer(file);
  };


  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
    SetData([])
    setSearchParams({})
  };

  // checks changed value of history and sets the searchParams
  const handleChange = (event) => {
    let searchParamsObj={}
      setSearchParams({})
      let filteredBatches2=JSON.parse(event).batches.map((b)=>{
        return b.trim()
      })
      for(let i=0;i<filteredBatches2.length;i++){
        searchParamsObj[`batch${i+1}`]=filteredBatches2[i] 
      }
      let filteredContests2=JSON.parse(event).problems.map((p)=>{
        let pObj={}
        pObj['problemName']=p.trim();
        return pObj;
      })
      for(let i=0;i<filteredContests2.length;i++){
        searchParamsObj[`p${i+1}`]=filteredContests2[i].problemName 
      }
      setParamsObj(searchParamsObj)
      setSearchParams(searchParamsObj)
      SetContests(filteredContests2)
      setfilteredContests(filteredContests2)
      const searchParams = {
        batches: filteredBatches2,
        problems: filteredContests2,
      }
        SetLoading(true);
        service
        .post("api/problems/status", searchParams)
        .then((json) => {
          let contests = getContests(json);

          SetPageSize(Math.max(10, Math.min(50, contests?.length)))
          SetData(contests);
          SetQueryButton(false);
          SetQueryText("Search Status");
          SetLoading(false);
        }).catch((error) => {
          SetLoading(false);
          SetData([]);
          console.log(error);
        })
  };

function BuildCSV() {
  const download_data = data;
  if (download_data.length === 0) {
    return;
  }

  const date = new Date();
  const date_options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const download_title =
    "ProblemSolvedStatus-" +
    date.toLocaleDateString(undefined, date_options) +
    " " +
    date.toLocaleTimeString("en-US");
  const fileName = download_title.split(" ").join("-") + ".xlsx";

  // Create a new workbook
  XlsxPopulate.fromBlankAsync().then((workbook) => {
    const sheet = workbook.sheet(0);
    let colIndex = 1;

    // Add the header row
    sheet.cell(1, colIndex).value("Rank").style("fill", TABLE_HEADER_COLOR);
    sheet.cell(1, colIndex + 1).value("Name").style("fill", TABLE_HEADER_COLOR);
    sheet.cell(1, colIndex + 2).value("Roll No").style("fill", TABLE_HEADER_COLOR);
    filteredContests.forEach((contest, i) => {
      sheet.cell(1, colIndex + 3 + i).value(contest.problemName).style("fill", TABLE_HEADER_COLOR);
    });
    sheet.cell(1, colIndex + 3 + filteredContests.length).value("Total Solved").style("fill", TABLE_HEADER_COLOR);
    sheet.cell(1, colIndex + 4 + filteredContests.length).value("Total Score").style("fill", TABLE_HEADER_COLOR);

    // Add the data rows
    download_data.forEach((row, rowIndex) => {
      sheet.cell(rowIndex + 2, colIndex).value(row.rank).style("fill", TABLE_BODY_COLOR);
      sheet.cell(rowIndex + 2, colIndex + 1).value(row.name || "NA").style("fill", TABLE_BODY_COLOR);
      sheet.cell(rowIndex + 2, colIndex + 2).value(row.rollNumber || "NA").style("fill", TABLE_BODY_COLOR);

      filteredContests.forEach((contest, i) => {
        const test = contest.problemName;
        const cell = sheet.cell(rowIndex + 2, colIndex + 3 + i);
        if (row.problems && row.problems[test]) {
          if (row.problems[test].participantType) {
            cell.value(row.problems[test].participantType).style("fill", PROBLEM_SOLVED_COLOR); // Green
          } else {
            cell.value("Solved").style("fill", PROBLEM_SOLVED_COLOR); // Green
          }
        } else {
          cell.value("NOT Solved " + String.fromCharCode(10060)).style("fill", PROBLEM_NOT_SOLVED_COLOR); // Red
        }
      });

      sheet.cell(rowIndex + 2, colIndex + 3 + filteredContests.length).value(row.totalSolved).style("fill", TABLE_BODY_COLOR);
      sheet.cell(rowIndex + 2, colIndex + 4 + filteredContests.length).value(row.totalScore).style("fill", TABLE_BODY_COLOR);
    });

    // Set column widths (optional)
    sheet.column(1).width(10);
    sheet.column(2).width(20);
    sheet.column(3).width(15);
    filteredContests.forEach((_, i) => {
      sheet.column(colIndex + 3 + i).width(30);
    });
    sheet.column(colIndex + 3 + filteredContests.length).width(15);
    sheet.column(colIndex + 4 + filteredContests.length).width(15);

    // Generate the Excel file as a Blob
    workbook.outputAsync().then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  });
}

  const removeFromHistory = (searchParams,keyInd)=>{
    let data=localStorage.getItem("history");
    data = JSON.parse(data)
    let filteredData =  data.filter((d,ind)=>{
        return ind!==keyInd
    })
    localStorage.setItem("history", JSON.stringify(filteredData))
    setHistoryChanged(!historyChanged)

  }
  const addToHistory = async (searchParams)=>{
    let data=localStorage.getItem("history");
    if(data){
      let flag=true
      data = JSON.parse(data)
      await data.map((d)=>{
        if(JSON.stringify(d)===JSON.stringify(searchParams)){
          flag=false
        }
      })
      if(flag){
        data.unshift(searchParams);
        data = data.slice(0, 10);
        localStorage.setItem("history", JSON.stringify(data))
      }
    }
    else{
      let data=[]
      data.push(searchParams);
      localStorage.setItem("history",JSON.stringify(data))
    }
    
  }


  function debounce(func, timeout = 1000){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
  const processChange = debounce((text) => SetSearchContests(text));

  function PaginationUpdate(){
    let Datalength = data?.length;
    if(Datalength === 0 || Datalength === null){
      SetPageSizeOption([5, 10, 15, 25, 50])
    }
    else{
    let pageOptions = []
    let defaultOptions = [5,10,20,25,50,100];
    defaultOptions.forEach(item => {
      const cur = Number(item);
      if(cur <= Datalength){
          pageOptions.push(cur)
      }
    })
    let num = 200;
    while(Number(num) <= Datalength){
      pageOptions.push(Number(num));
      num += 100;
    }
    if(pageOptions[pageOptions.length - 1] != Datalength){
      pageOptions.push(Number(Datalength));
    }
    SetPageSizeOption(pageOptions);
  }
  }

  function PopulatedFill(){
    let Datalength = data?.length;
    if(Page === FinalPage){
      let cur_size = PageSize;
      if(cur_size === 0){
        cur_size = 10;
      }
      const res = Datalength % cur_size;
      if(!isNaN(res) && res !== 0){
        SetPageSize(res);
      }
    }
  }

  useEffect(()=>{
    let data=localStorage.getItem("history");
    if(data){
      data=JSON.parse(data)
      data=data.map((d)=>{
        let obj={}
        let bats = d.batches.map((b)=>{
          return b+" "
        })
        obj['batches']=bats
        let probs=d.problems.map((p)=>{
          return p.problemName+" "
        })
        obj['problems']=probs
        return JSON.stringify(obj)
      })
      SetHistoryData(data)
    }
  },[data,historyChanged])


  

  useEffect(() => {
    let isLogin = util.loggedIn();
    let admin = util.isAdmin();
    SetRole(util.getRole());
    SetIsAdmin(admin);
    SetLoggedIn(isLogin);
    if (!isLogin && window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
    if (isLogin && admin) {
      service.get("api/batches").then(json => {
        let batches = ['All Batches'];
        json.batches.map((batch) => {batches.push(batch)});
        SetBatches(batches);
      })
      .catch((err) =>{
        console.log(err);
      })

      service
      .get("api/sites/options")
      .then((json) => {
        SetSitesOptions(json);
      }).catch((error) => {
        console.log(error);
      })

    
    }
  }, []);

  useEffect(()=>{
    SetLoading(true)
    let qBatches = []
    let qProblems = []
    if(searchParams.get("batch")){
      qBatches.push(searchParams.get("batch"));
    }
    let i=1;
    while(searchParams.get(`batch${i}`)){
      qBatches.push(searchParams.get(`batch${i}`))
      i+=1;
    }
    i=1;
    while(searchParams.get(`p${i}`)){
      qProblems.push({"problemName":searchParams.get(`p${i}`)})
      i+=1;
    }
    const searchParams3 = {
      batches: qBatches,
      problems: qProblems,
    }
    setfilteredContests(qProblems)
    if ( searchParams3 &&  searchParams3?.batches?.length > 0  &&  searchParams3?.problems?.length > 0  ) {
      SetLoading(true);
      service
      .post("api/problems/status",  searchParams3)
      .then((json) => {
        let contests = getContests(json);

        SetPageSize(Math.max(10, Math.min(50, contests?.length)))
        SetData(contests);
        SetQueryButton(false);
        SetQueryText("Search Status");
        SetLoading(false);
      }).catch((error) => {
        SetData([]);
        console.log(error);
        SetLoading(false);
      })
    }
    else{
      SetData([]);
      SetLoading(false)
    }

    
  },[])

  const handleSubmit = async () => {
    const searchParams = {
      batches: filteredBatches,
      problems: filteredContests,
    }
    await addToHistory(searchParams);
    if (searchParams && searchParams?.batches?.length > 0 && filteredSites && searchParams?.problems?.length > 0  ) {
      SetLoading(true);
      service
      .post("api/problems/status", searchParams)
      .then((json) => {
        let contests = getContests(json);

        SetPageSize(Math.max(10, Math.min(50, contests?.length)))
        SetLoading(false);
        SetData(contests);
        SetQueryButton(false);
        SetQueryText("Search Status");
        if(open){
          handleClose();
        }
      }).catch((error) => {
        SetLoading(false);
        SetData([]);
        console.log(error);
      })
    }
    else{
      SetData([]);
    }
  }

  const processColumns = () => {
      let newColumns = [
          {
            Header: "USER DETAILS",
            fixed: "left",
            columns: [
              {
                Header: "Rank",
                accessor: "rank",
                width: 100,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? '#0F9ADC' : '',
                    },
                  };
                },
              },
              {
                Header: "Name",
                accessor: "name",
                width: 250,
                Cell: e => <a
                  style={{ color: "white", textDecoration: "underline" }}
                  target="_blank" href={"/coding/profile/" + e.original.userId}> {e.value} </a>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? '#0F9ADC' : '',
                    },
                  };
                },
              },
              {
                Header: "Roll No",
                accessor: "rollNumber",
                width: 150,
                Cell: e => <a 
                style={{ color: "white" }}
                >{
                  (!e.value)?  "NA" : e.value}</a>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? '#0F9ADC' : '',
                    },
                  };
                },
              },
            ],
          },
          {
            Header: "PROBLEMS",
            columns: filteredContests.map((contest) => {
              return {
                Header: contest?.problemName,
                accessor: contest?.problemName,
                sortable: false,
                width: 150,
                Cell: e => e ? <a
                  style={{ color: "white" }}
                  target="_blank" href={e?.problemName}> {
                    ((e?.original?.problems) && e.original?.problems[contest?.problemName]) ?  "Solved" : "Not Solved"
                  } </a> : "Not Solved",
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo && Object.keys(rowInfo?.original?.problems || {}).includes(contest?.problemName) ?  '#1AAD03' : '#FA2A55',
                    },
                  };
                },
              }
            })
          },
          {
            Header: "STATISTICS",
            fixed: "right",
            columns: [
              {
                Header: "Total Solved",
                accessor: "totalSolved",
                width: 150,
                Cell: e => <a
                  style={{ color: "white" }}
                  >{e.value}</a>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? '#0F9ADC' : '',
                    },
                  };
                },
              },
              {
                Header: "Total Score",
                accessor: "totalScore",
                width: 150,
                Cell: e => <a
                  style={{ color: "white" }}
                  >{e.value}</a>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      background: rowInfo ? '#0F9ADC' : '',
                    },
                  };
                },
              },
            ],
          }
      ]


      return newColumns;
  }

  useEffect(() => {
    PaginationUpdate();
  }, [data])

  useEffect(() => {
    PopulatedFill();
  }, [Page, FinalPage])

  useEffect(() => {
    if (searchContests && filteredSites && searchContests.length > 0) {
      searchContests =  searchContests.replace(/\//g, '_');
      SetLoadingProblems(true);
      service
      .get("api/problems/" + filteredSites + "/" +  searchContests)
      .then((json) => {
        SetContests(json);
        SetLoadingProblems(false);
      }).catch((error) => {
        console.log(error);
        SetLoadingProblems(false);
      })
    }
    else{
      SetContests([]);
    }
  }, [searchContests]);

  useEffect(() => {
      if(filteredBatches.length > 0 && filteredSites && filteredContests.length > 0){
        SetQueryText("Update Status");
        SetQueryButton(true);
      }
      else{
        SetQueryText("Search Status");
        SetQueryButton(false);
      }
  }, [filteredContests, filteredBatches]);

  return (
    <div
      className=" text-center text-dark h2 "
      style={{ minHeight: "100vh", fontWeight: "revert-layer" }}
    >
      <p className="mt-4">Problem Solved Status</p>

      {checked && (
        <FormControl fullWidth style={{ width: "98%", margin: "1%" }}>
          <InputLabel id="demo-simple-select-label">history</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Age"
            //onChange={handleChange}
            value={searchParams}
          >
            {historyData?.map((hdata, ind) => {
              return (
                <div className="d-flex justify-content-between overflow-auto">
                  <a onClick={() => handleChange(hdata)} className="overflow-auto">
                    <MenuItem value={hdata}>
                      batch-[{JSON.parse(hdata).batches}] | problems-[
                      {JSON.parse(hdata).problems}]
                    </MenuItem>
                  </a>
                  <div style={{padding: 4}}>
                  <TbTrash
                    style={{ cursor: "pointer", color: "red" }}
                    size={30}
                    onClick={() => removeFromHistory(hdata, ind)}
                  />
                  </div>
                </div>
              );
            })}
          </Select>
        </FormControl>
      )}

      <div
        className="p-0 m-0 h5 text-primary "
        style={{
          textDecoration: "none",
          fontWeight: "600",
          textShadow: "0px 0px #C0C0C0",
        }}
      >
        <VscCloudDownload
          data-bs-toggle="tooltip"
          title="Download Problem Solved Data"
          data-bs-placement="bottom"
          size={40}
          style={{
            cursor: "pointer",
            position: "absolute",
            top: 60,
            right: 10,
            zIndex: 100,
          }}
          onClick={BuildCSV}
        />

        <div>
          <VscCloudUpload
            data-bs-toggle="tooltip"
            title="Upload Problem Data"
            data-bs-placement="bottom"
            size={40}
            style={{
              cursor: "pointer",
              position: "absolute",
              top: 60,
              right: 60,
              zIndex: 100,
            }}
            onClick={handleOpen}
          />
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
            }}>
              <h2 id="modal-modal-title">Upload Excel File</h2>
              {getSampleData()}
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
              />
              <Button onClick={handleClose}>Close</Button>
              { loading && <div style={{padding: 10}}><BeatLoader size={10} color="#1976d2"/></div> }
              {filteredBatches.length>0 && filteredContests.length>0 && !loading && (
                <Button onClick={() => {
                  handleSubmit();
                  handleClose();
                }}>Update</Button>
              )}
            </Box>
          </Modal>
        </div>

        <div
          style={{
            position: "absolute",
            top: 60,
            left: 10,
            padding: "10px",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={checked}
                onChange={handleChangeCheck}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="History"
          />
        </div>
      </div>

      {!checked && (
        <div style={{ verticalAlign: "middle" }}>
          <Autocomplete
            multiple
            disableCloseOnSelect
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            loading={loadingProblems}
            options={
              filteredBatches.includes("All Batches")
                ? ["All Batches"]
                : batches
            }
            sx={{
              width: 300,
              display: "inline-block",
              marginRight: 6,
              verticalAlign: "middle",
            }}
            onChange={(event, newValue) => {
              setfilteredBatches(newValue);
              if (newValue && newValue.length > 0) {
                if (newValue[0] === "All Batches") {
                  setSearchParams({ batch: "all-batches" });
                  setParamsObj({ batch: "all-batches" });
                  return;
                }
                let searchParamsObj = {};
                for (let i = 0; i < newValue.length; i++) {
                  searchParamsObj[`batch${i + 1}`] = newValue[i];
                }
                let tObj = {
                  batchParams: { ...searchParamsObj },
                  ...paramsObj.siteParams,
                  ...paramsObj.problemParams,
                };
                setSearchParams({
                  ...tObj.batchParams,
                  ...tObj.siteParams,
                  ...tObj.problemParams,
                });
                setParamsObj(tObj);
              } else {
                let tObj = {
                  batchParams: {},
                  siteParams: {},
                  problemParams: {},
                };
                setSearchParams({});
                setParamsObj(tObj);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select Batches" />
            )}
          />
          <Autocomplete
            disablePortal
            id="checkboxes-tags-demo"
            renderOption={(props, option, { selected }) => (
              <li {...props}>{option}</li>
            )}
            options={SiteOptions}
            sx={{
              width: 200,
              display: "inline-block",
              marginRight: 6,
              verticalAlign: "middle",
            }}
            onChange={(event, newValue) => {
              if (newValue && newValue.length > 0) {
                setfilteredSites(newValue);
              } else {
                setfilteredSites("*");
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select Site" />
            )}
          />

          <Autocomplete
            multiple
            disableCloseOnSelect
            isOptionEqualToValue={(option, value) => {
              for (let i = 0; i < filteredContests.length; i++) {
                if (filteredContests[i].problemName === option.problemName)
                  return true;
              }
              return false;
            }}
            filterOptions={(x) => {
              return x;
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {filteredSites === "CODEFORCES"
                  ? option.problemName + " (" + option.problemId + ")"
                  : option.problemName}
              </li>
            )}
            loading={loadingProblems}
            options={contests}
            getOptionLabel={(option) =>
              filteredSites === "CODEFORCES"
                ? option.problemName + " (" + option.problemId + ")"
                : option.problemName
            }
            sx={{ width: 600, display: "inline-block" }}
            onChange={(event, newValue) => {
              setfilteredContests(newValue);
              if (newValue && newValue.length > 0) {
                let searchParamsObj = {};
                for (let i = 0; i < newValue.length; i++) {
                  searchParamsObj[`p${i + 1}`] = newValue[i].problemName;
                }
                let tempObj = {
                  batchParams: { ...paramsObj.batchParams },
                  siteParams: { ...paramsObj.siteParams },
                  problemParams: { ...searchParamsObj },
                };
                setSearchParams({
                  ...tempObj.batchParams,
                  ...tempObj.siteParams,
                  ...tempObj.problemParams,
                });
                setParamsObj(tempObj);
              } else {
                let tempObj = {
                  batchParams: { ...paramsObj.batchParams },
                  siteParams: { ...paramsObj.siteParams },
                  problemParams: {},
                };
                setSearchParams({
                  ...tempObj.batchParams,
                  ...tempObj.siteParams,
                  ...tempObj.problemParams,
                });
                setParamsObj(tempObj);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                onChange={(e) => {
                  processChange(e.target.value);
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loadingProblems ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
                sx={{
                  width: 600,
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                label="Select Problems"
              />
            )}
          />
          <Button
            onClick={handleSubmit}
            disabled={!QueryButton}
            variant="contained"
            color="primary"
            style={{
              marginLeft: "36px",
              height: "50px",
              verticalAlign: "middle",
            }}
          >
            {QueryText}
          </Button>
        </div>
      )}

      {loading ? (
        <div
          style={{
            marginTop: "10vh",
            marginRight: "10vh",
            textAlign: "center",
          }}
        >
          <FadeLoader margin={5} color="green" />
        </div>
      ) : null}

      {!loading && data.length > 0 && (
        <ReactTableFixedColumns
          data={data}
          style={{
            textAlign: "center",
            fontWeight: "bolder",
            fontSize: "16px",
            height: "auto",
            marginTop: "20px",
          }}
          pageSize={PageSize}
          pageSizeOptions={PageSizeOption}
          minRows={5}
          loadingText={"Loading Participation Data..."}
          onPageSizeChange={(pageSize, pageIndex) => {
            SetPage(pageIndex);
            SetPageSize(pageSize);
          }}
          onPageChange={(num) => {
            SetPage(num);
          }}
          renderTotalPagesCount={(num) => {
            if (!isFinite(num) || isNaN(num)) {
              num = 1;
            }
            SetFinalPage(num);
            if (num === 0) {
              return 1;
            }
            return num;
          }}
          columns={processColumns()}
        />
      )}
    </div>
  );
}

export default ProblemReport;

